import { BASE_API_URL } from "../../../config/url";

export const PROFILE_DONE = "PROFILE_DONE";
export const UPDATE_PROFILE_DONE = "UPDATE_PROFILE_DONE";

export const PROFILE_DONE_ERROR = "PROFILE_DONE_ERROR";
export const UPDATE_PROFILE_DONE_ERROR = "UPDATE_PROFILE_DONE_ERROR";

export const PROFILE_API_URL = `${BASE_API_URL}/onboarding`;
